"use client";

import {useEffect, useState} from 'react';
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectValue,
  SelectItem
} from '@/components/ui/select';
import { Globe } from 'lucide-react';
import { Locales } from '@/app/[lang]/dictonaries';
import { usePathname, useRouter  } from 'next/navigation';
import { log } from 'console';

type LanguageSelectProps = {
  locale: Locales;
};

export default function LanguageSelect({ locale }: LanguageSelectProps) {
  // Maybe we should define supported languages in dictionaries.ts?
  const languages = ['en', 'fi'];
  const pathName = usePathname();
  const router = useRouter();
  const defaultIndex = languages.includes(locale.toLowerCase()) ? languages.indexOf(locale.toLowerCase()): 0;

  function changeLanguageHandler(val: string) {
    if (val === locale) return;

    // Set both cookie and localStorage for backward compatibility
    localStorage.setItem('lang', val);
    
    // Set cookie for server-side access
    const expires = new Date();
    expires.setTime(expires.getTime() + (365 * 24 * 60 * 60 * 1000));
    document.cookie = `lang=${val};expires=${expires.toUTCString()};path=/`;

    const segments = pathName.split('/');
    segments[1] = val; 
    const newPath = segments.join('/');
    router.push(newPath);
  }

  return (
    <Select onValueChange={changeLanguageHandler} defaultValue={languages[defaultIndex]}>
      <SelectTrigger className="w-fit gap-2 bg-transparent border-none [&>svg]:text-white [&>svg]:opacity-100">
        <SelectValue
          placeholder={<Globe className="text-white" />}
        ></SelectValue>
      </SelectTrigger>
      <SelectContent className="min-w-fit w-fit justify-start bg-transparent border-none backdrop-blur-3xl backdrop-brightness-75 rounded-3xl p-2">
        {languages.map((lang) => (
          <SelectItem
            key={lang}
            value={lang}
            className="w-fit group cursor-pointer data-[state=checked]:bg-transparent data-[state=checked]:text-white hover:data-[state=checked]:text-gray-400"
          >
            <div className="text-white flex items-center justify-between w-fit">
              <span className="group-hover:text-gray-400">{lang.toUpperCase()}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
